import { render } from "./FileImport.vue?vue&type=template&id=53cbf202&scoped=true"
import script from "./FileImport.vue?vue&type=script&lang=js"
export * from "./FileImport.vue?vue&type=script&lang=js"

import "./FileImport.vue?vue&type=style&index=0&id=53cbf202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cbf202"]])

export default __exports__